// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e81f38e","551":"f80c2f28"}[chunkId] + ".chunk.js";
};